// The wall's tile sizes, smallest first, in pixels across.
export const tileSizes = [200, 280, 400] as const

// The gap between tiles, gap-3.5.
const gap = 14

const fits = (width: number, px: number) => Math.max(1, Math.floor((width + gap) / (px + gap)))

// wallColumns is how many columns of tiles a wall this wide shows at a size.
// Each size gets at least one column fewer than the size below it, wherever
// there is room for more than one: auto-fill stretched whatever fitted, so at
// many widths two sizes came to the same count and switching between them
// changed nothing (#288).
export function wallColumns(width: number, px: number): number {
  let columns = Infinity
  for (const size of tileSizes) {
    columns = Math.max(1, Math.min(fits(width, size), columns - 1))
    if (size === px) return columns
  }
  return fits(width, px)
}
